import { useEffect, useState } from "react";
import { Link } from "react-router";
import { mensagemDoConsole } from "../../nucleo/console";
import {
  destinoDoResultado,
  ONDE_O_TERMO_APARECEU,
  TAMANHO_MINIMO_DA_BUSCA,
  useBuscaGlobal,
} from "../../nucleo/operacao";
import { podeNaSessao, useSessao } from "../../nucleo/sessao";

const ESPERA_DA_DIGITACAO_EM_MS = 250;

/**
 * A pesquisa global do console: um campo só, resultados agrupados por assunto. O servidor decide
 * o que cada pessoa encontra (permissão de cada grupo e isolamento por organização); a tela só
 * mostra o que vier — e não pergunta nada enquanto o termo é curto demais.
 */
export function BuscaGlobal({ interno }: { interno: boolean }) {
  const sessao = useSessao();
  const [digitado, setDigitado] = useState("");
  const [termo, setTermo] = useState("");
  const [aberta, setAberta] = useState(false);
  const busca = useBuscaGlobal(termo);

  useEffect(() => {
    const espera = setTimeout(() => setTermo(digitado), ESPERA_DA_DIGITACAO_EM_MS);
    return () => clearTimeout(espera);
  }, [digitado]);

  if (!podeNaSessao(sessao.data, "busca:global")) return null;
  const podeEditarArtigos = podeNaSessao(sessao.data, "conhecimento:editar");
  const limpo = digitado.trim();
  const curto = limpo.length < TAMANHO_MINIMO_DA_BUSCA;

  function fechar() {
    setAberta(false);
    setDigitado("");
    setTermo("");
  }

  return (
    <search className="busca-global" data-testid="busca-global" aria-label="Pesquisa do console">
      <label className="busca-global__rotulo" htmlFor="busca-global-campo">
        <span className="sr-only">Pesquisar no portal</span>
        <input
          id="busca-global-campo"
          className="campo__controle busca-global__campo"
          type="search"
          autoComplete="off"
          placeholder="Chamado, empresa, pessoa, artigo ou ativo"
          maxLength={100}
          value={digitado}
          onChange={(evento) => {
            setDigitado(evento.target.value);
            setAberta(true);
          }}
          onFocus={() => setAberta(true)}
          onKeyDown={(evento) => {
            if (evento.key === "Escape") fechar();
          }}
        />
      </label>
      {aberta && !curto ? (
        <div className="busca-global__resultados" role="region" aria-label="Resultados da pesquisa">
          {busca.isError ? (
            <p role="alert">{mensagemDoConsole(busca.error)}</p>
          ) : busca.isPending || termo.trim() !== limpo ? (
            <p role="status">Pesquisando…</p>
          ) : busca.data.grupos.length === 0 ? (
            <p role="status">Nada encontrado para “{busca.data.termo}”.</p>
          ) : (
            busca.data.grupos.map((grupo) => (
              <section key={grupo.chave} aria-label={grupo.rotulo} data-testid={`busca-${grupo.chave}`}>
                <h3 className="titulo-secao">{grupo.rotulo}</h3>
                <ul>
                  {grupo.itens.map((item) => (
                    <li key={item.id}>
                      <Link
                        to={destinoDoResultado(grupo.chave, item, interno, podeEditarArtigos)}
                        onClick={fechar}
                      >
                        {item.titulo}
                      </Link>
                      <span className="nota-rodape">
                        {item.detalhe ? ` · ${item.detalhe}` : ""}
                        {item.achado_em ? ` · ${ONDE_O_TERMO_APARECEU[item.achado_em] ?? ""}` : ""}
                      </span>
                    </li>
                  ))}
                </ul>
                {grupo.mais ? (
                  <p className="nota-rodape">Há mais resultados. Refine o termo para ver outros.</p>
                ) : null}
              </section>
            ))
          )}
        </div>
      ) : null}
    </search>
  );
}
